export default "__VITE_ASSET__DUS4DWPq__"